export enum SessionStorageKeys {
  storedSectionIndicesState = 'storedSectionIndicesState',
}
